import React, { FC, MutableRefObject, useEffect, useRef, useState } from "react";
// libs
import { DateTime } from "luxon";
// components
import Select from "src/components/ui/Select";
import DatePicker from "src/components/ui/calendar/DatePicker";
// theme
import { Wrapper, DaypickerContainer } from "./styles";

interface ISelectDatepicker {
  onChangeCb?: (date: string) => void;
}

const SelectDatepicker: FC<ISelectDatepicker> = ({ onChangeCb }) => {
  const dropdownCalendar: MutableRefObject<HTMLDivElement | null> = useRef(null);

  const [openDate, setOpenDate] = useState<boolean>(false);
  const [chosenDate, setChosenDate] = useState(new Date());
  const calendarValue = DateTime.fromJSDate(chosenDate).toFormat("d LLLL");

  const closeDropdownDate = (e: MouseEvent) => {
    setOpenDate(false);
    e?.stopPropagation();
  };

  const handleClickDateOutside = (event: MouseEvent): void => {
    if (!dropdownCalendar.current?.contains(event.target as HTMLDivElement)) {
      closeDropdownDate(event);
    }
  };

  useEffect(() => {
    if (openDate) {
      document.addEventListener("mousedown", handleClickDateOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickDateOutside);
    };
  }, [openDate]);

  const handleOpenCalendar = () => setOpenDate(!openDate);

  const onChoseDate = (date: Date) => {
    setChosenDate(date);
    onChangeCb?.(DateTime.fromJSDate(date).toFormat("dd/LL/yyyy"));
  };

  return (
    <Wrapper>
      <Select
        isClearable={false}
        menuIsOpen={false}
        onMenuOpen={handleOpenCalendar}
        value={{
          label: calendarValue,
          value: calendarValue,
        }}
      />
      {openDate && (
        <DaypickerContainer ref={dropdownCalendar}>
          <DatePicker choosedDate={onChoseDate} handleOpenCalendar={handleOpenCalendar} />
        </DaypickerContainer>
      )}
    </Wrapper>
  );
};

export default SelectDatepicker;
